import {useMatch} from '@github-ui/react-router'
import {
  ArtifactsRoutePath,
  ChangesRoutePath,
  ChecksRoutePath,
  CommitsRoutePath,
  FilesRoutePath,
  FindingsRoutePath,
  WalkthroughRoutePath,
} from '../routes/route-paths'
import {useIsOverviewEnabled} from './use-feature-state'

export type PullRequestActiveRoute =
  | 'overview'
  | 'conversation'
  | 'files_changed'
  | 'commits'
  | 'checks'
  | 'findings'
  | 'artifacts'
  | 'walkthrough'

/** Returns which pull request route is currently active. */
export function useActiveRoute(): PullRequestActiveRoute {
  const isFiles = useMatch(`${FilesRoutePath}/*`) !== null // will only trigger from React partial in Rails Files Changed
  const isChanges = useMatch(`${ChangesRoutePath}/*`) !== null
  const isCommits = useMatch(`${CommitsRoutePath}/*`) !== null
  const isChecks = useMatch(`${ChecksRoutePath}/*`) !== null
  const isFindings = useMatch(`${FindingsRoutePath}/*`) !== null
  const isArtifacts = useMatch(`${ArtifactsRoutePath}/*`) !== null
  const isWalkthrough = useMatch(`${WalkthroughRoutePath}/*`) !== null

  const overviewIsIndexRoute = useIsOverviewEnabled()

  if (isFiles || isChanges) return 'files_changed'
  if (isCommits) return 'commits'
  if (isChecks) return 'checks'
  if (isFindings) return 'findings'
  if (isArtifacts) return 'artifacts'
  if (isWalkthrough) return 'walkthrough'

  if (overviewIsIndexRoute) return 'overview'
  return 'conversation'
}
